import pick from 'lodash/pick';

import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { getAuthorData, offerExpireReminderNotifyToUser, sendVerificationCode, transactionLineItems, updateTransactionMetadata, userPhoneNumberValidation, verifyCode } from '../../util/api';
import * as log from '../../util/log';
import { denormalisedResponseEntities } from '../../util/data';
import { findNextBoundary, getStartOf, monthIdString } from '../../util/dates';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
} from '../../util/urlHelpers';
import { DOTS_PROCESS_NAME, getProcess, isBookingProcessAlias } from '../../transactions/transaction';
import { fetchCurrentUser, fetchCurrentUserHasOrdersSuccess } from '../../ducks/user.duck';
import { isStockInUse } from '../../util/search';
import { fetchAuthorDetails, getOrderNumber, sendSmsNotificationToUsers, stripeCustomer } from '../CheckoutPage/CheckoutPage.duck';
import { CATEGORY_ACCESSORY, COUNTRY_CODE, getSentOfferText } from '../../util/types';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/ListingPage/SET_INITIAL_VALUES';

export const SHOW_LISTING_REQUEST = 'app/ListingPage/SHOW_LISTING_REQUEST';
export const SHOW_LISTING_ERROR = 'app/ListingPage/SHOW_LISTING_ERROR';

export const FETCH_REVIEWS_REQUEST = 'app/ListingPage/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/ListingPage/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/ListingPage/FETCH_REVIEWS_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/ListingPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/ListingPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/ListingPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/ListingPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/ListingPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/ListingPage/FETCH_LINE_ITEMS_ERROR';

export const SEND_INQUIRY_REQUEST = 'app/ListingPage/SEND_INQUIRY_REQUEST';
export const SEND_INQUIRY_SUCCESS = 'app/ListingPage/SEND_INQUIRY_SUCCESS';
export const SEND_INQUIRY_ERROR = 'app/ListingPage/SEND_INQUIRY_ERROR';

export const FETCH_USER_LISTINGS_REQUEST = 'app/ListingPage/FETCH_USER_LISTINGS_REQUEST';
export const FETCH_USER_LISTINGS_SUCCESS = 'app/ListingPage/FETCH_USER_LISTINGS_SUCCESS';
export const FETCH_USER_LISTINGS_ERROR = 'app/ListingPage/FETCH_USER_LISTINGS_ERROR';

export const FETCH_SUGGESTED_LISTINGS_REQUEST = 'app/ListingPage/FETCH_SUGGESTED_LISTINGS_REQUEST';
export const FETCH_SUGGESTED_LISTINGS_SUCCESS = 'app/ListingPage/FETCH_SUGGESTED_LISTINGS_SUCCESS';
export const FETCH_SUGGESTED_LISTINGS_ERROR = 'app/ListingPage/FETCH_SUGGESTED_LISTINGS_ERROR';

export const FETCH_AUTHOR_DATA_REQUEST = 'app/ListingPage/FETCH_AUTHOR_DATA_REQUEST';
export const FETCH_AUTHOR_DATA_SUCCESS = 'app/ListingPage/FETCH_AUTHOR_DATA_SUCCESS';
export const FETCH_AUTHOR_DATA_ERROR = 'app/ListingPage/FETCH_AUTHOR_DATA_ERROR';

export const USER_PHONE_NUMBER_REQUEST = 'app/ListingPage/SAVE_PAYOUT_DETAILS_REQUEST';
export const USER_PHONE_NUMBER_SUCCESS = 'app/ListingPage/SAVE_PAYOUT_DETAILS_SUCCESS';
export const USER_PHONE_NUMBER_ERROR = 'app/ListingPage/SAVE_PAYOUT_DETAILS_ERROR';

// ================ Reducer ================ //

const initialState = {
  id: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,

  fetchUserListingInProgress: false,
  listings: [],
  fetchUserListingsError: null,

  fetchSugesstedListingInProgress: false,
  suggestedListings: [],
  fetchSuggestedListingsError: null,

  monthlyTimeSlots: {
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  sendInquiryInProgress: false,
  sendInquiryError: null,
  inquiryModalOpenForListingId: null,

  authorData: null,
  fetchAuthorDataError: null,

  validationInProgress: false,
  isPhonNumberExit: false,
  validationError: null
};

const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SHOW_LISTING_REQUEST:
      return { ...state, id: payload.id, showListingError: null };
    case SHOW_LISTING_ERROR:
      return { ...state, showListingError: payload };

    case FETCH_REVIEWS_REQUEST:
      return { ...state, fetchReviewsError: null };
    case FETCH_REVIEWS_SUCCESS:
      return { ...state, reviews: payload };
    case FETCH_REVIEWS_ERROR:
      return { ...state, fetchReviewsError: payload };

    case FETCH_USER_LISTINGS_REQUEST:
      return { ...state, fetchUserListingsError: null, fetchUserListingInProgress: true };
    case FETCH_USER_LISTINGS_SUCCESS:
      return { ...state, listings: payload, fetchUserListingInProgress: false };
    case FETCH_USER_LISTINGS_ERROR:
      return { ...state, fetchUserListingsError: payload, fetchUserListingInProgress: false };

    case FETCH_SUGGESTED_LISTINGS_REQUEST:
      return { ...state, fetchUserListingsError: null, fetchSugesstedListingInProgress: true };

    case FETCH_SUGGESTED_LISTINGS_SUCCESS:
      return { ...state, suggestedListings: payload, fetchSugesstedListingInProgress: false };
    case FETCH_SUGGESTED_LISTINGS_ERROR:
      return { ...state, fetchSuggestedListingsError: payload, fetchSugesstedListingInProgress: false };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case SEND_INQUIRY_REQUEST:
      return { ...state, sendInquiryInProgress: true, sendInquiryError: null };
    case SEND_INQUIRY_SUCCESS:
      return { ...state, sendInquiryInProgress: false };
    case SEND_INQUIRY_ERROR:
      return { ...state, sendInquiryInProgress: false, sendInquiryError: payload };

    case FETCH_AUTHOR_DATA_REQUEST:
      return { ...state, fetchAuthorDataError: null };
    case FETCH_AUTHOR_DATA_SUCCESS:
      return { ...state, authorData: payload };
    case FETCH_AUTHOR_DATA_ERROR:
      return { ...state, fetchAuthorDataError: payload };

    case USER_PHONE_NUMBER_REQUEST:
      return {
        ...state,
        validationInProgress: true,
        validationError: null,
        isPhonNumberExit: null,
      };

    case USER_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        validationInProgress: false,
        isPhonNumberExit: payload,
        validationError: null
      };
    case USER_PHONE_NUMBER_ERROR:
      return {
        ...state,
        validationInProgress: false,
        validationError: payload,
        isPhonNumberExit: null,
      };

    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const showListingRequest = id => ({
  type: SHOW_LISTING_REQUEST,
  payload: { id },
});

export const showListingError = e => ({
  type: SHOW_LISTING_ERROR,
  error: true,
  payload: e,
});

export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
export const fetchReviewsSuccess = reviews => ({ type: FETCH_REVIEWS_SUCCESS, payload: reviews });
export const fetchReviewsError = error => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: error,
});

export const fetchUserListingsRequest = () => ({ type: FETCH_USER_LISTINGS_REQUEST });
export const fetchUserListingsSuccess = listings => ({
  type: FETCH_USER_LISTINGS_SUCCESS,
  payload: listings,
});
export const fetchUserListingsError = error => ({
  type: FETCH_USER_LISTINGS_ERROR,
  error: true,
  payload: error,
});

export const fetchSuggestedListingsRequest = () => ({
  type: FETCH_SUGGESTED_LISTINGS_REQUEST,
});

export const fetchSuggestedListingsSuccess = listings => ({
  type: FETCH_SUGGESTED_LISTINGS_SUCCESS,
  payload: listings,
});
export const fetchSuggestedListingsError = error => ({
  type: FETCH_SUGGESTED_LISTINGS_ERROR,
  error: true,
  payload: error,
});

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const sendInquiryRequest = () => ({ type: SEND_INQUIRY_REQUEST });
export const sendInquirySuccess = () => ({ type: SEND_INQUIRY_SUCCESS });
export const sendInquiryError = e => ({ type: SEND_INQUIRY_ERROR, error: true, payload: e });

export const fetchAuthorDataRequest = () => ({ type: FETCH_AUTHOR_DATA_REQUEST });
export const fetchAuthorDataSuccess = data => ({ type: FETCH_AUTHOR_DATA_SUCCESS, payload: data });
export const fetchAuthorDataError = error => ({ type: FETCH_AUTHOR_DATA_ERROR, error: true, payload: error });

export const userPhoneNumberRequest = () => ({
  type: USER_PHONE_NUMBER_REQUEST,
});

export const userPhoneNumberSuccess = response => ({
  type: USER_PHONE_NUMBER_SUCCESS,
  payload: response,
});

export const userPhoneNumberError = error => ({
  type: USER_PHONE_NUMBER_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ /

export const suggestedListing = (params) => (dispatch, getState, sdk) => {
  dispatch(fetchSuggestedListingsRequest());
  const { productType, minStockMaybe, size } = params || {};
  const sizes = productType == CATEGORY_ACCESSORY ? {} : { pub_size: size }
  return sdk.listings
    .query({ pub_productType: productType, pub_markForSale: true, ...minStockMaybe, state: ['published'], ...sizes })
    .then((res) => {
      dispatch(fetchSuggestedListingsSuccess(res.data.data));
    }).catch((err) => {
      dispatch(fetchUserListingsError(storableError(err)));
    });
};

export const getOtherListings = (authorId, minStockMaybe) => (dispatch, getState, sdk) => {
  dispatch(fetchUserListingsRequest());
  return sdk.listings
    .query({ authorId, pub_markForSale: true, ...minStockMaybe, state: ['published'] })
    .then(res => {
      dispatch(fetchUserListingsSuccess(res.data.data));
    })
    .catch(err => {
      dispatch(fetchUserListingsError(storableError(err)));
    });
};

export const fetchAuthorData = authorId => (dispatch, getState, sdk) => {
  dispatch(fetchAuthorDataRequest());
  return getAuthorData({ authorId })
    .then((response) => {
      dispatch(fetchAuthorDataSuccess(response));
      return response;
    })
    .catch((error) => {
      dispatch(fetchAuthorDataError(storableError(error)));
      throw error;
    });
};

export const showListing = (listingId, config, isOwn = false) => (dispatch, getState, sdk) => {
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;
  const minStockMaybe = isStockInUse(config) ? { minStock: 1 } : {};
  dispatch(showListingRequest(listingId));
  dispatch(fetchCurrentUser());
  const params = {
    id: listingId,
    include: ['author', 'author.profileImage', 'images', 'currentStock'],
    'fields.image': [
      // Scaled variants for large images
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-large',
      'variants.scaled-xlarge',

      // Cropped variants for listing thumbnail images
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,

      // Social media
      'variants.facebook',
      'variants.twitter',

      // Avatars
      'variants.square-small',
      'variants.square-small2x',
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
  };

  const show = isOwn ? sdk.ownListings.show(params) : sdk.listings.show(params);

  return show
    .then(data => {
      const { productType, size } = data?.data?.data?.attributes?.publicData;
      const { author } = (data && data.data && data.data.data && data.data.data.relationships) || {};
      const authorId = author?.data?.id?.uuid || '';
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };
      dispatch(addMarketplaceEntities(data, sanitizeConfig));
      dispatch(fetchUserListingsRequest());
      if (authorId) {
        dispatch(suggestedListing({ productType, minStockMaybe, size }));
        dispatch(getOtherListings(authorId, minStockMaybe));
        dispatch(fetchAuthorData(author?.data?.id))
      }
      return data;
    })
    .catch(e => {
      dispatch(showListingError(storableError(e)));
    });
};

export const fetchReviews = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchReviewsRequest());
  return sdk.reviews
    .query({
      listing_id: listingId,
      state: 'public',
      include: ['author', 'author.profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const reviews = denormalisedResponseEntities(response);
      dispatch(fetchReviewsSuccess(reviews));
    })
    .catch(e => {
      dispatch(fetchReviewsError(storableError(e)));
    });
};

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdString(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    perPage: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

export const sendInquiry = (listing, message, sellerPhoneNumber) => (dispatch, getState, sdk) => {
  dispatch(sendInquiryRequest());
  const processAlias = listing?.attributes?.publicData?.transactionProcessAlias;
  const { enableNotifications = true } = listing?.author?.attributes?.profile?.publicData || {};
  if (!processAlias) {
    const error = new Error('No transaction process attached to listing');
    log.error(error, 'listing-process-missing', {
      listingId: listing?.id?.uuid,
    });
    dispatch(sendInquiryError(storableError(error)));
    return Promise.reject(error);
  }

  const listingId = listing?.id;
  const [processName, alias] = processAlias.split('/');
  const transitions = getProcess(processName)?.transitions;

  const bodyParams = {
    transition: 'transition/inquire-message',
    processAlias: `${DOTS_PROCESS_NAME}/release-1`,
    params: { listingId, protectedData: { message: true } },
  };
  return sdk.transactions
    .initiate(bodyParams)
    .then(response => {
      const transactionId = response.data.data.id;

      // Send the message to the created transaction
      return sdk.messages.send({ transactionId, content: message }).then(() => {
        updateTransactionMetadata({
          id: transactionId,
          isProviderRead: false,
          isCustomerRead: true,
        });
        dispatch(sendInquirySuccess());
        dispatch(fetchCurrentUserHasOrdersSuccess(true));
        if (enableNotifications) {
          const params = {
            to: `${COUNTRY_CODE}${sellerPhoneNumber}`, orderId: transactionId?.uuid, transactionType: "sale", message: `${getSentOfferText(listing?.attributes?.title)}`,
            type: "message"
          };
          dispatch(sendSmsNotificationToUsers(params));
        };
        return transactionId;
      });
    })
    .catch(e => {
      dispatch(sendInquiryError(storableError(e)));
      throw e;
    });
};

// Helper function for loadData call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const unitType = attributes?.publicData?.unitType;
    const timeUnit = unitType === 'hour' ? 'hour' : 'day';
    const nextBoundary = findNextBoundary(new Date(), timeUnit, tz);

    const nextMonth = getStartOf(nextBoundary, 'month', tz, 1, 'months');
    const nextAfterNextMonth = getStartOf(nextMonth, 'month', tz, 1, 'months');

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

export const fetchTransactionLineItems = ({ orderData, listingId, isOwnListing }) => (dispatch, getState) => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ orderData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
      dispatch(getOrderNumber());
      // Order forms only pass quantity/deliveryMethod in orderData, so resolve
      // the full listing entity (with publicData.boxSizes) from the store —
      // the shipping rate fetch needs the package dimensions.
      const listing =
        orderData.listing ||
        getMarketplaceEntities(getState(), [{ id: listingId, type: 'listing' }])[0];
      dispatch(fetchAuthorDetails({ listing, cartItems: orderData.cartItems }));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};

export const reminderMailNotification = (data) => (dispatch, getState, sdk) => {
  try {
    offerExpireReminderNotifyToUser({ ...data });
  } catch (error) {
    console.log(error, '((( ))) => error');
  }
};

export const loadData = (params, search, config) => dispatch => {
  const listingId = new UUID(params.id);

  // Clear old line-items
  dispatch(setInitialValues({ lineItems: null }));

  const ownListingVariants = [LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT];
  if (ownListingVariants.includes(params.variant)) {
    return dispatch(showListing(listingId, config, true));
  }

  return Promise.all([
    dispatch(showListing(listingId, config)),
    dispatch(fetchReviews(listingId)),
    dispatch(stripeCustomer()),
    dispatch(getOrderNumber())
  ]).then(response => {
    const listing = response[0]?.data?.data || {};
    const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';
    if (isBookingProcessAlias(transactionProcessAlias)) {
      // Fetch timeSlots.
      // This can happen parallel to loadData.
      // We are not interested to return them from loadData call.
      fetchMonthlyTimeSlots(dispatch, listing);
    }
    return response;
  });
};

export const sendPhoneVerificationCode = verificationData => async (dispatch, getState, sdk) => {
  dispatch(userPhoneNumberRequest());
  try {
    const response = await userPhoneNumberValidation(verificationData);
    if (response) {
      dispatch(userPhoneNumberSuccess(response.isUserPhoneNumberAlreadyExit));
    }
    if (!response.isUserPhoneNumberAlreadyExit) {
      const result = await sendVerificationCode(verificationData);
    }
  } catch (error) {
    dispatch(userPhoneNumberError(storableError(error)));
  }
};

export const verifiedCode = verificationData => async (dispatch, getState, sdk) => {
  try {
    const result = await verifyCode(verificationData);
    if (result) {
      dispatch(
        updateProfile({
          protectedData: { phoneNumber: verificationData.phoneNumber.replace(/^(\+91|\+1)/, ""), isPhoneNumberVerified: true },
        })
      );
    }
    return result;
  } catch (error) { }
};